/**
 * Configuration data for the session. This data can be modified by the teacher from the admin panel
 */
export class SessionConfig {
    totalRounds;
    debug;
    drill;
    seed;
    // both durations are measured in seconds
    roundDuration;
    breakDuration;
    roundAttacks;
    sessionId;

    /** Factory Function
	 * @param {bool} drill
	 * @param {number} totalRounds
	 * @param seed
	 * @param {bool} debug
	 * @param {number} sessionId
	 * @return {SessionConfig} instance
	 */
    static build(drill, totalRounds, seed, roundDuration, breakDuration, debug, sessionId, roundAttacks) {
        let instance = new SessionConfig();
        instance.drill = drill;
        instance.totalRounds = totalRounds;
        instance.seed = seed;
        instance.debug = debug;
        instance.sessionId = sessionId;
        instance.roundDuration = roundDuration;
        instance.breakDuration = breakDuration;
        instance.roundAttacks = roundAttacks;
        return instance;
    }

    /**
	 * See Session.js for documentation on import statements
	 */
    static jsonDeserialize(data) {
        let instance = new SessionConfig();
        instance.drill = data.drill;
        instance.totalRounds = data.total_rounds;
        instance.seed = data.seed;
        instance.debug = data.debug;
        instance.sessionId = data.session_id;
        instance.roundDuration = data.round_duration;
        instance.breakDuration = data.break_duration;
        instance.roundAttacks = data.round_attacks;
        return instance;
    }

    toJSON() {
        return {
            total_rounds: this.totalRounds,
            debug: this.debug,
            drill: this.drill,
            seed: this.seed,
            round_duration: this.roundDuration,
            break_duration: this.breakDuration,
            session_id: this.sessionId,
            round_attacks: this.roundAttacks
        };
    }

    getSessionId() {
        return this.sessionId;
    }

    getSeed() {
        return this.seed;
    }

    isDebug() {
        return this.debug;
    }

    getTotalRounds() {
        return this.totalRounds;
    }

    isDrill() {
        return this.drill;
    }

    getBreakDuration() {
        return this.breakDuration;
    }

    getRoundDuration() {
        return this.roundDuration;
    }

    getRoundAttacks() {
        return this.roundAttacks
    }
}